const data = {
  ayush: {
    linkedin: "https://www.linkedin.com/in/ayush-gupta-1020a9253/",
    github: "https://github.com/ayush1108g",
    email: "22EC01057@iitbbs.ac.in",
    instagram: "https://www.instagram.com/ayush__1108/",
  },
  divya: {
    linkedin: "https://www.linkedin.com/in/divya-kumar-87a845265/",
    github: "https://github.com/Divyakumar6163",
    email: "22ME02040@iitbbs.ac.in",
    instagram: "https://www.instagram.com/divya_kumar_5161/",
  },
  pushkar: {
    linkedin: "https://www.linkedin.com/in/pushkar-gupta-153546208/",
    github: "https://github.com/22push",
    email: "22EE01018@iitbbs.ac.in",
    instagram: "https://www.instagram.com/pushkar_06_07/",
  },
};
export default data;
